<script lang="ts" setup>
import type { ProductAttributeValueSlotDto } from '@repo/api/web/models'

const props = defineProps<{
  attribute: ProductAttributeValueSlotDto
}>()

const displayValue = computed(() => {
  const raw = props.attribute.values[0]?.value
  if (raw === 'true' || raw === '1') return 'Да'
  if (raw === 'false' || raw === '0') return 'Нет'
  return null
})
</script>

<template>
  <UiAttribute
    :label="props.attribute.metadata.displayName"
    :content="displayValue"
    :ui="{ label: 'text-muted text-sm' }"
  />
</template>
